import React from 'react'

import { Card, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { TrainingWizardData } from 'modules/trainings/components/Revamp/NewTrainingWizard/types'

type Props = {
  onChange(data: Partial<TrainingWizardData>): void
  subsidized: boolean
}

export function SubsidizeToggle({ onChange, subsidized }: Props) {
  const toggle = (value: boolean) => {
    onChange({
      subsidized: value,
    })
  }

  return (
    <Card>
      <Card.Title
        size="small"
        action={<TogglerCheckbox onChange={(value) => toggle(value)} value={subsidized} />}
      >
        {i18n.t('trainings.subsidy.toggle.card.title')}
      </Card.Title>
      <Card.Description>{i18n.t('trainings.subsidy.toggle.card.description')}</Card.Description>
    </Card>
  )
}
